module.exports = __webpack_public_path__ + "static/img/product_3.c985c16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_3.jpg
// module id = +DCH
// module chunks = 1